const NOTICE_SORT = {
    /**
     * 일반
     */
    GENERAL: "001",
    /**
     * 자료실
     */
    REFERENCE: "002",
    /**
     * 업데이트
     */
    UPDATE: "003",
    /**
     * 제품정보
     */
    PRODUCT_INFORMATION: "004",
    /**
     * 업계동향
     */
    INDUSTRY_TRENDS: "005",
};

const POPUP_TYPE = {
    /**
     * 등록 팝업 타입
     */
    REGISTER: 'register',
    /**
     * 수정 팝업 타입
     */
    EDIT: 'edit',
    /**
     * 알수 없는 팝업 타입
     */
    UNKNOWN: 'unknown',
}

const CODE = {
    NOTICE_SORT,
    // BUTTON_TYPE,
    POPUP_TYPE,
}

export {CODE}
